import React from 'react';
import { Label, Input, FormGroup } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import { ReactComponent as Info } from '../../assets/images/info-icon.svg';
import { DropDownInput } from "../inputs/DropDownInput";
import styles from '../FileClaim/Payment.module.css';
import RoutingNumberIcon from '../../assets/images/bank-routing-number.svg';
import AccountNumberIcon from '../../assets/images/bank-acct-number.svg';

const accountOptions = [
    {
        data: "checking",
        display: "Checking",
    },
    {
        data: "savings",
        display: "Savings",
    }
];
export default function PaymentAccountInputs(props) {
    const { state, validator, handleInputChange } = props;

    return (<div>
        <FormGroup className={state.showAccountValidations && state.errors.bankAccountType && state.validationFired ? "form-error" : ""}>
            <Label htmlFor="bankAccountType" className="form-label">Account Type</Label>
            <span aria-hidden="true" className="required-indicator">*</span>
            <DropDownInput
                name="bankAccountType"
                options={accountOptions}
                className="form-control"
                onChangedValue={(e) => handleInputChange({target: {name: "bankAccountType", value: e}})}
                placeholder="Please select..."
                id="bankAccountType"
                defaultValue={state.bankAccountType}
            />
            {state.showAccountValidations && validator.message("accountType", state.bankAccountType,  "required")}
        </FormGroup>

        <FormGroup className={validator.message("routingNumber", state.bankRoutingNumber, "required|min:9|max:9") ? "form-error" : ""}>
            <Label htmlFor="bankRoutingNumber" className="form-label">Routing Number</Label>
            <span aria-hidden="true" className="required-indicator">*</span>
            <div className={styles.inputTooltip}>
                <span className={styles.hasTooltip}>
                    <Info data-tip data-for='routingTooltip' aria-labelledby='tooltip' aria-label="Routing Number" className={styles.infoIcon} />
                    <ReactTooltip
                        id='routingTooltip'
                        tabIndex="0"
                        clickable="true"
                        aria-haspopup='true'
                        className={styles.tooltiptext}
                        effect="solid"
                        type="light"
                        place={"bottom", "right"}
                        border={true}>
                        <img
                            width="100%"
                            height="100%"
                            alt="Routing Number"
                            src={RoutingNumberIcon}
                        />
                    </ReactTooltip>
                </span>
                <Input
                    id="bankRoutingNumber"
                    name="bankRoutingNumber"
                    type="number"
                    value={state.bankRoutingNumber}
                    onChange={handleInputChange}
                />
            </div>
            {state.showAccountValidations && validator.message("routingNumber", state.bankRoutingNumber, "required|size:9", { messages: {size: 'Invalid routing number'} })}
        </FormGroup>

        <FormGroup className={(validator.message("accountNumber", state.bankAccountNumber, "required|max:17") || (state.errors.bankAccountNumber && state.errors.bankAccountNumberInvalid)) ? "form-error" : ""}>
            <Label htmlFor="bankAccountNumber" className="form-label">Account Number</Label>
            <span aria-hidden="true" className="required-indicator">*</span>
            <div className={styles.inputTooltip}>
                <span className={styles.hasTooltip}>
                    <Info data-tip data-for='accountTooltip' aria-labelledby='tooltip' aria-label="Account Number" className={styles.infoIcon} />
                    <ReactTooltip
                        id='accountTooltip'
                        tabIndex="0"
                        clickable="true"
                        aria-haspopup='true'
                        className={styles.tooltiptext}
                        effect="solid"
                        type="light"
                        place={"bottom", "right"}
                        border={true}>
                        <img
                            width="100%"
                            height="100%"
                            alt="Account Number"
                            src={AccountNumberIcon}
                        />
                    </ReactTooltip>
                </span>
                <Input
                    id="bankAccountNumber"
                    name="bankAccountNumber"
                    type="number"
                    onChange={handleInputChange}
                    value={state.bankAccountNumber}
                />
            </div>
            { validator.message("accountNumber", state.bankAccountNumber, "required|max:17")}
            {state.errors.bankAccountNumber && state.errors.bankAccountNumberInvalid && (
                <div className="errorMsg" aria-live="polite">Invalid account number.</div>
            )}
        </FormGroup>
    </div>)
}